// components/TestimonialsSection.tsx

type Testimonial = {
  name: string;
  role: string;
  message: string;
  rating: number; // ⭐ New property
};

const testimonials: Testimonial[] = [
  {
    name: "Emma et Christophe",
    role: "CEO, ICT",
    message:
      "Nous avons fait appel à Montransfert Sàrl pour notre mariage, et le service a été exceptionnel du début à la fin. La voiture était impeccable, le chauffeur très professionnel et ponctuel, et tout s’est déroulé sans stress. Nos invités ont aussi apprécié le confort du transport. Merci encore pour avoir contribué à rendre ce jour encore plus spécial !",
    rating: 5,
  },
  
];

// ⭐ Star renderer
const renderStars = (count: number) => {
  return (
    <div className="mb-4 text-yellow-400 text-lg">
      {[1, 2, 3, 4, 5].map((i) => (
        <span key={i} className={i <= count ? "text-yellow-400" : "text-gray-300"}>
          ★
        </span>
      ))}
    </div>
  );
};

export default function TestimonialsSection() {
  return (
    <section 
    id="temoignages"
    className="bg-white py-20 px-4 sm:px-8 lg:px-16"
    >
      <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">
       Témoignages de nos clients
      </h2>
      <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-2">
        {testimonials.map((t, index) => (
          <div
            key={index}
            className="bg-gray-50 shadow-md rounded-lg p-6 flex flex-col items-center text-center hover:shadow-lg transition-shadow"
          >
            {renderStars(t.rating)}

            <p className="text-gray-600 italic mb-4">"{t.message}"</p>
            <div>
              <p className="text-lg font-semibold text-gray-800">{t.name}</p>
             {/* <p className="text-sm text-gray-500">{t.role}</p>*/}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
